import { useAtomValue } from 'jotai'
import useSmartAccount from 'src/common/api-clients/safe-protocol-kit/useSmartAccount'
import useOwnedCarbonTokens from 'src/common/apollo/hooks/useOwnedCarbonTokens'
import useVicc from 'src/common/queries/useVicc'
import { viccCountAtom } from '../../bundle-store'
import useCarbonBundleInfo from 'src/common/contracts/hooks/carbon-bundles/useCarbonBundleInfo'

const useCarbonBundleDepositState = () => {
  const {
    carbonBundleInfo: { depositFee },
  } = useCarbonBundleInfo()
  const { smartAccountInfo } = useSmartAccount()
  const {
    ownedCarbonTokens,
    total,
    loading: ownedCarbonLoading,
  } = useOwnedCarbonTokens(smartAccountInfo?.address)
  const viccCount = useAtomValue(viccCountAtom)
  const depositFeeNum = Number(depositFee?.toString() || '0') / 10000
  const receivedValue =
    depositFeeNum > 0 ? viccCount - viccCount * depositFeeNum : viccCount

  const { vicc, isLoading: viccLoading } = useVicc()

  const maxValue = Math.min(total, 100)

  const loading = ownedCarbonLoading || viccLoading

  return {
    ownedCarbonTokens: ownedCarbonTokens || [],
    receivedValue,
    loading,
    viccNfts: ownedCarbonTokens,
    maxValue,
    vicc,
  }
}

export default useCarbonBundleDepositState
